import SelectVersus from "./SelectVersus";

export default SelectVersus;